import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { DocumentPreview } from "./DocumentPreview";

interface DocumentPreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  html: string;
  filename: string;
}

export function DocumentPreviewDialog({
  isOpen,
  onClose,
  html,
  filename
}: DocumentPreviewDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl h-[80vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>{filename}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-hidden">
          <DocumentPreview content={html} />
        </div>
      </DialogContent>
    </Dialog>
  );
}